import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link, useParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import { getAllBusinessCardData, getAllBusinessHeader, getAllBusinessParagraph, getByPartnerIdBusinessFooter } from "../../api/axios";

function ForBusiness() {
  const { partnerId } = useParams();
  const [headerImgId, setHeaderImgId] = useState(null);
  const [bottomTitle, setBottomTitle] = useState(null);
  const [cardView, setCardView] = useState(null);


  const [paragraphid, setParagraphId] = useState(null);
  useEffect(() => {
    if (!Number(partnerId)) return;
    fetchParagraphData();
    fetchHeaderData();
    fetchCardViewData();
    fetchBottomViewData();
  }, [partnerId]);

  const fetchParagraphData = async () => {
    try {
      const response = await getAllBusinessParagraph(partnerId);
      console.log(response.data.data[0]);
      if (response.data.data.length > 0) {
        setParagraphId(response.data.data[0].id);
        console.log(response.data.data[0].id);
      } else {
        console.log(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };
  
  const fetchHeaderData = async () => {
    try {
      const response = await getAllBusinessHeader(partnerId);
      console.log(response.data.data[0]);
      if (response.data.data.length > 0) {
        setHeaderImgId(response.data.data[0].bus_header_id);
        console.log('response: ', response);
      } else {
        console.log(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCardViewData = async () => {
    try {
      const response = await getAllBusinessCardData(partnerId);
      console.log(response.data.data[0]);
      if (response.data.data.length > 0) {
        setCardView(response.data.data[0].card_id);
      } else {
        console.log(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchBottomViewData = async () => {
    try {
      const response = await getByPartnerIdBusinessFooter(partnerId);
      console.log(response.data.data[0]);
      if (response.data.data.length > 0) {
        setBottomTitle(response.data.data[0]?.id);
      } else {
        console.log(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <ContentWrapper>
      {partnerId ? (
        <>
          {" "}
          <Title>Select a section</Title>
          <SectionWrapper>
            <Link to={`/${partnerId}/forbusiness/headerimg/view/${Number(headerImgId) ? headerImgId : 'create' }`}>
              <Button className="mb-0">Header Paragraph 1 Section</Button>
            </Link>
            <Link
              to={`/${partnerId}/forbusiness/headerparagraphtwo/view/${Number(paragraphid) ? paragraphid : 'create' }`}
            >
              <Button className="mb-0">Header Paragraph 2 Section</Button>
            </Link>
            <Link to={`/${partnerId}/forbusiness/card/view/${Number(cardView) ? cardView : 'create' }`}>
              <Button className="mb-0">Cards Section</Button>
            </Link>
            <Link to={`/${partnerId}/forbusiness/bottomtitle/view/${Number(bottomTitle) ? bottomTitle : 'create' }`}>
              <Button className="mb-0">Bottom Section</Button>
            </Link>
          </SectionWrapper>
        </>
      ) : (
        <Title>Select a partner first!</Title>
      )}
    </ContentWrapper>
  );
}

export default ForBusiness;
const ContentWrapper = styled.div`
   @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
`;

const Title = styled.h3`
  text-align: center;
  @media (min-width:576px) {
   margin-bottom: .5rem;
  }
   @media (min-width:768px) {
    margin-bottom: 1rem;
  }
   margin-bottom: .25rem;
`;

const SectionWrapper = styled.div`
  /* justify-content: center;
  align-items: center;
  gap: 12px; */
  display: flex;
  gap: 6rem;
  justify-content: center;
  // padding-top: 5rem;
    @media (max-width:1400px) {
    gap: 2rem !important;
   }
     @media (max-width:1200px) {
    gap: 1rem !important;
   }
      @media (max-width:694px) {
   flex-wrap: wrap;
   }
     @media (max-width:369px) {
   flex-direction:column;
   gap: 0.5rem !important;
   }
`;
